import { initReactI18next } from 'react-i18next';
import * as Sentry from '@sentry/browser';
import i18n from 'i18next';
import backend from 'i18next-http-backend';

import { convertToLocale } from './localeConverter';

const loadTranslations = (
  apiUrl: string,
  merchantId: string,
  userId: string,
  sessionId: string,
  country: string,
  language: string,
) => {
  const token = btoa(`${merchantId}:${userId}:${sessionId}`);

  return fetch(`${apiUrl}/api/v1/cashier/translations?country=${country}`, {
    headers: {
      'Pgw-Authorization': token,
      'Accept-Language': language,
    },
  });
};

const initI18n = (apiUrl: string): void => {
  const params = new URLSearchParams(window.location.search);

  const country = params.get('country') || '';
  const merchantId = params.get('merchantId');
  const userId = params.get('userId');
  const sessionId = params.get('sessionId');

  const acceptLanguage = convertToLocale(params.get('language') || 'en');

  if (!merchantId || !userId || !sessionId) {
    return;
  }

  const backendOptions = {
    loadPath: '{{lng}}|{{ns}}',
    request: (_: any, url: any, __: any, callback: any) => {
      try {
        const [lng] = url.split('|');

        loadTranslations(apiUrl, merchantId, userId, sessionId, country, lng)
          .then((resp) => {
            if (!resp.ok) {
              throw new Error(
                `Failed to load translations: ${resp.status} ${resp.statusText}`,
              );
            }

            return resp.json();
          })
          .then((resp) => {
            if (!resp.data) {
              throw new Error('Invalid translation response format');
            }

            callback(null, {
              data: resp.data,
              status: 200,
            });
          })
          .catch((error) => {
            callback(null, {
              data: [],
              status: 200,
            });

            Sentry.captureException(
              new Error('####Fetch translation error. Error####: '),
              {
                extra: {
                  error,
                },
              },
            );
          });
      } catch (error) {
        Sentry.captureException(
          new Error('####Translation loading failed. Error####: '),
          {
            extra: {
              error,
            },
          },
        );

        callback(null, {
          data: [],
          status: 200,
        });
      }
    },
  };

  i18n
    .use(backend)
    .use(initReactI18next)
    .init({
      lng: acceptLanguage,
      fallbackLng: acceptLanguage,
      load: 'currentOnly',
      keySeparator: false,
      backend: backendOptions,
      debug: false,
      interpolation: {
        escapeValue: false,
        formatSeparator: ',',
      },
    });
};
export { i18n, initI18n };
